import checkout from "./form";

const {
  formField: { auth, code },
} = checkout;

export default {
  [code.name]: "",
  [auth.name]: "",
};
